import { useEffect, useState } from 'react';
import { getCarrierDropdown } from '../api';
import { CarrierDropdown } from '../interfaces';

const initialState = {
  isLoading: false,
  carrierList: [],
};

export default function useCarrierDropdown(isAdmin: boolean) {
  const [carrierDropdownList, setDropdownList] = useState<CarrierDropdown[]>(
    [],
  );
  const [isLoadingCarriers, setIsLoadingCarriers] = useState<boolean>(false);

  const fetchCarrierDropdown = async (payload: any) => {
    const { carrierList } = await getCarrierDropdown(setIsLoadingCarriers);
    setDropdownList(carrierList);
  };

  useEffect(() => {
    setIsLoadingCarriers(initialState.isLoading);
    setDropdownList(initialState.carrierList);
    fetchCarrierDropdown(initialState);
  }, [isAdmin]);

  return {
    carrierDropdownList,
  };
}
